import { Component, Input, HostBinding } from "@angular/core";

@Component({
    selector: 'npn-logo',
    template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 391 391"><g>
        <path class="swirl-top" d="M182,1c-36.3,2.4-68.6,13.4-95.3,32.5c-5.6,4-11.8,8.7-13.7,10.4l-3.5,3L73,46c5.8-1.6,15.6-1.2,22.2,1.1
                c9.4,3.1,19.3,10.1,30.3,21.3C137.1,80.2,145.6,91,168,122c17.1,23.8,26.5,34.3,39.5,44.2c16.2,12.4,28.9,16.3,49.5,15.5
                c21.7-0.9,38.4-7.7,53.2-21.6c17.4-16.3,25.7-36.1,25.8-61c0-10.3,0-10.3-2.2-9.6c-21.5,6.6-48.9,3.2-72.9-9.1
                c-27.3-14.1-51.2-45.7-48.4-64.1c0.7-5.1,6-11,10.6-12c5.3-1,3-2.1-5.8-2.7C199.9,0.4,193.3,0.3,182,1z"/>
        <path class="swirl-top" d="M256.5,5.9c-8.8,0.9-11.6,1.9-13.9,5.3c-2.2,3.1-2,6.5,0.8,12.5c6.1,13.1,19.8,28.5,30.3,34
                c11,5.9,28.3,8.6,41.2,6.4l6.5-1.1l8.2,4.5c4.5,2.5,8.7,4.5,9.3,4.5c2.5,0,0.8-4.1-3.6-9l-4.6-5.2l-0.1-10.2
                c-0.1-9.3-0.4-10.7-3.3-16.7c-5.4-10.8-16-19.1-30-23.2C291.1,5.8,267.9,4.8,256.5,5.9z M315.8,40.2c2.7,2.7,0.7,7.8-2.9,7.8
                c-2.1,0-4.9-2.6-4.9-4.5C308,40,313.3,37.7,315.8,40.2z"/>
        <path class="swirl-top" d="M72.5,50.6c-9.9,2.3-10.4,2.6-18.8,11.3c-4.5,4.7-11.1,12.2-14.6,16.6c-9.7,12.3-26,37.8-23,35.9
                c0.8-0.5,4.6-3,8.6-5.7c9.7-6.4,23.9-13.1,34.8-16.3c8-2.5,10.6-2.7,24-2.7s15.9,0.2,23.8,2.6c4.8,1.5,12.4,4.5,16.9,6.8l8.1,4.1
                l-3.8-6.9c-11.6-20.8-25.7-37.2-36.6-42.2C85.7,51.2,76.8,49.6,72.5,50.6z"/>
        <path class="swirl-left" d="M354.6,81.9c1.3,5,0.7,31.5-1,40.5c-4.6,24.2-16.5,43.5-35.4,57.4c-14.1,10.4-23.8,14.3-55.1,22.2
                c-23.8,6-32.9,8.9-44.6,14.5c-22.7,10.9-35.8,23.3-45,42.6c-5.4,11.5-7.5,21.2-7.5,35.1c0,15.5,1.9,23.6,8.5,37.4
                c10.3,21.3,27.7,35.9,51.2,43c7.6,2.4,10.6,2.7,22.3,2.8c15.3,0,23.2-1.5,34.5-6.7c19-8.6,31.2-17.5,48-34.8
                c17.5-18,28.4-33.6,39.6-56.3c28.1-57.2,26.1-119.5-5.7-181.6C358.2,85.8,353.6,78.3,354.6,81.9z M329.4,194.2
                c-30.6,42.4-63.6,80-84.9,96.8c-13.1,10.3-34,19-49.9,20.6l-6.4,0.7l-0.7-7.7c-1.4-14.8,2.6-33.4,9.7-45.3
                c5-8.5,14.6-17.5,23.6-22.1c8.9-4.7,17.5-7.3,43.7-13.7c10.5-2.6,23.5-6.4,29.1-8.6c10.9-4.2,24.4-12.7,33.4-20.8
                c3-2.8,5.7-5.1,5.8-5.1C333,189,331.5,191.4,329.4,194.2z"/>
        <path class="swirl-right" d="M67.5,108c-17.8,3.8-37.3,16-48,30.2C8.7,152.5,3.6,167,2,187.1C-0.1,215,7.8,248,24.4,280.3
                c34.1,66.3,95.1,104.5,174.1,109.1l9,0.5l-6.5-1.4c-56.1-12.9-106.1-51.7-136.8-106.2c-14.5-25.7-20.6-47.5-20.7-73.8
                c0-23.4,4.2-40,14.8-57.7c4.2-6.9,12.6-17.3,13.4-16.5c0.2,0.3-1.6,4.5-4,9.3C58.6,161.8,55,177.6,55,199c0,37.8,14.2,78,39.4,111.7
                c14.5,19.5,39,42.1,58.8,54.2c14.9,9,31.2,16.2,46.5,20.5c14.6,4,15.2,3.9,5.5-1.4c-45.2-24.2-65.1-62.5-55.7-107.3
                c0.9-4.3,3.9-15.1,6.6-24c9.7-31.5,12.1-43.7,12-63c0-9.1-0.5-14.3-2.1-20.2C154.6,125.4,111.9,98.7,67.5,108z"/>
    </g></svg>
    `,
    styles:[`
    :host {
        display: block;
    }
    svg {
        width: 100%;
        height: 100%;
    }
    :host.spin > svg {
        animation-name: spin;
        animation-duration: 1250ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
    `]
})
export class NpnLogoComponent {
    @Input() @HostBinding('class.spin') spin:boolean = false;
}
